import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useI18n } from "../i18n";
import { api } from "../lib/api";
import { AuthCard } from "../components/auth/AuthCard";

const inputCls = "h-12 w-full rounded-xl border border-slate-200 px-4 text-base text-navy outline-none focus:border-brand focus:ring-4 focus:ring-brand/15";

export default function SetPassword() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    api.get("/auth/token-info", { params: { token } }).then((r) => setInfo(r.data)).catch(() => setInfo(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setError(t("auth.pwShort"));
    if (password !== confirm) return setError(t("auth.pwMismatch"));
    try {
      await api.post("/auth/set-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(t("auth.linkInvalid"));
    }
  };

  const title = info?.purpose === "invite" ? t("auth.inviteTitle") : t("auth.resetTitle");
  return (
    <AuthCard title={info === false ? t("auth.linkInvalid") : title} subtitle={info ? info.email : ""} testId="set-password-card">
      {info && !done && (
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t("auth.newPassword")} className={inputCls} data-testid="set-password-input" />
          <input type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder={t("auth.confirmPassword")} className={inputCls} data-testid="set-password-confirm" />
          {error && <p role="alert" className="rounded-xl bg-rose-50 px-4 py-3 text-sm text-rose-700" data-testid="set-password-error">{error}</p>}
          <button type="submit" data-testid="set-password-submit" className="h-12 w-full rounded-xl bg-brand text-base font-semibold text-white hover:bg-[#25a065]">{t("auth.savePassword")}</button>
        </form>
      )}
      {done && <p className="mt-6 rounded-xl bg-brand/10 px-4 py-3 text-sm text-navy" data-testid="set-password-done">{t("auth.passwordSet")}</p>}
      <Link to="/login" className="mt-5 block text-center text-sm font-medium text-brand" data-testid="set-password-login-link">{t("auth.backToLogin")}</Link>
    </AuthCard>
  );
}
